import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

// Enrollment dates are calendar dates stored in a timestamptz column. Anchoring both
// reads and writes to UTC midnight keeps the stored instant on the day the user
// actually picked, and keeps the 1950-01-01 sentinel rendering as 1950 rather than
// 1949 for viewers west of UTC. Never format an enrollment date with a bare dayjs().
export const ENROLLMENT_DATE_SENTINEL = "1950-01-01T00:00:00.000Z";

export const defaultEnrollmentDate = (): string =>
  dayjs.utc(dayjs().format("YYYY-MM-DD")).toISOString();

export const enrollmentDateFieldProps = {
  getValueProps: (value: unknown) => ({
    value: value ? dayjs.utc(value as string) : "",
  }),
  normalize: (value: Dayjs | null) =>
    value ? dayjs.utc(value.format("YYYY-MM-DD")).toISOString() : value,
};

export const formatEnrollmentDate = (raw: unknown): string =>
  raw ? dayjs.utc(raw as string).format("DD-MMM-YYYY") : "";
